/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ControllerSpeedEvent extends alm.event.Event {

		public static CHANGE:string = 'ControllerSpeedEvent.CHANGE';





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, requiredState:number) {
			super(eventType, target);
			this.requiredState = requiredState;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getRequiredState():number {
			return this.requiredState;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private requiredState:number;
	}
}
